<section class="fbk">
  <div class="step-stats">
    <div class="step-stat" [attr.data-tone]="successfulContactsCount ? 'ok' : null">
      <span class="step-stat__value">{{ formatCount(successfulContactsCount) }}</span>
      <span class="step-stat__label">
        <span class="step-dot" [attr.data-tone]="successfulContactsCount ? 'ok' : 'idle'"></span>
        Added
      </span>
    </div>
    @if (sentCount !== null) {
      <!-- Skipped is not a failure: the count stays in ink, the dot carries the tone. -->
      <div class="step-stat">
        <span class="step-stat__value">{{ formatCount(skippedCount) }}</span>
        <span class="step-stat__label">
          <span class="step-dot" [attr.data-tone]="skippedCount ? 'wait' : 'idle'"></span>
          Skipped, already in your contacts
        </span>
      </div>
    }
    <div class="step-stat" [attr.data-tone]="failedContactsCount ? 'bad' : null">
      <span class="step-stat__value">{{ formatCount(failedContactsCount) }}</span>
      <span class="step-stat__label">
        <span class="step-dot" [attr.data-tone]="failedContactsCount ? 'bad' : 'idle'"></span>
        Failed
      </span>
    </div>
    @if (sentCount !== null) {
      <div class="step-stat">
        <span class="step-stat__value">{{ formatCount(sentCount) }}</span>
        <span class="step-stat__label">Rows sent</span>
      </div>
    }
  </div>

  @if (skippedCount) {
    <div class="step-notice">
      <span class="bk-sym" aria-hidden="true">info</span>
      <p class="step-notice__text">
        {{ formatCount(skippedCount) }} {{ skippedCount === 1 ? 'row was' : 'rows were' }} skipped because the phone
        number is already saved. Those contacts were not changed or duplicated.
      </p>
    </div>
  }

  @if (failedContactsCount) {
    <div class="step-notice is-error">
      <span class="bk-sym" aria-hidden="true">error</span>
      <p class="step-notice__text">
        {{ formatCount(failedContactsCount) }} {{ failedContactsCount === 1 ? 'row' : 'rows' }} could not be added.
        Download them with the reason for each, fix them in your spreadsheet and import that file.
      </p>
      <div class="step-notice__actions">
        <button type="button" class="bk-btn bk-btn--ghost" (click)="downloadFailedRows()">
          <span class="bk-sym" aria-hidden="true">download</span>
          Download failed rows
        </button>
      </div>
    </div>
  }

  <app-routing-tab class="fbk__tabs" [tabList]="viewTabs" />

  <csv-feedback-contacts-table [currentView]="currentView" />
</section>

<stepper-controls
  class="sticky bottom-0"
  leftButtonLabel="Import another file"
  rightButtonLabel="Done"
  (leftButtonClick)="importAnother()"
  (rightButtonClick)="done()"
/>
